export const environment = {
  production: false,
  images_url_head: 'https://creativesham.blob.core.windows.net/progad/',
  apiDealerUrl: 'https://www.fdcampaignstudio.com/api/udldelta/dealers/getdata',
  msalConfig: {
    auth: {
      clientId: '7d13af4f-cae2-4a7c-80be-d006df1bcd77', 
      authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0', 
      redirectUri: 'https://qa.fdcampaignstudio.com/', 
    },
    cache: {
      cacheLocation: 'BrowserCacheLocation.LocalStorage',
      storeAuthStateInCookie: false,
    },
  },
  
  apiAdvDealerUrl: 'https://qaapi.fdcampaignstudio.com/dco/advDealers',
  apiAdvDealerFLsUrl: 'https://qaapi.fdcampaignstudio.com/dco/advDealers/uploadFloodlights',
  apiDealersUrl: 'https://qaapi.fdcampaignstudio.com/dco/dealers',
  apiUserUrl: 'https://qaapi.fdcampaignstudio.com/dco/dcousers/login',
  apiPostDealerUrl: 'https://qaapi.fdcampaignstudio.com/dco/dealers',
  apiPostUserUrl:
    'https://qaapi.fdcampaignstudio.com/dco/dcousers',
  apiPatchUserUrl:
    'https://qaapi.fdcampaignstudio.com/dco/dcousers',
  apiAllUsers: 'https://qaapi.fdcampaignstudio.com/dco/dcousers',
  apiAllDealers: 'https://qaapi.fdcampaignstudio.com/dco/advDealers',
  apiPostOemOffers: 'https://qaapi.fdcampaignstudio.com/dco/oemoffers',
  apiPlacementsUrl: 'https://qaapi.fdcampaignstudio.com/dco/placements',
  apiPostDcoUrl: 'https://qaapi.fdcampaignstudio.com/dco/campaigns',
  apiNewDcoUrl: 'https://qaapi.fdcampaignstudio.com/dco/ads?pacode=',
  apiPostNewDcoUrl: 'https://qaapi.fdcampaignstudio.com/dco/ads',
  apiDcoUrl: 'https://qaapi.fdcampaignstudio.com/dco/campaigns?pacode=',
  offerInfo:
    'https://www.servicesus.ford.com/incentives/SpecialOffers.json?appContext=T2&',
  uploadAzureZip: 'https://creativesham.blob.core.windows.net/html5templates/',
  downloadAzureZip:
    'https://creativesham.blob.core.windows.net/html5templates/',
  uploadImagesUrl: 'https://creativesham.blob.core.windows.net/imagetest/',
  getImagesUrl:
    'https://creativesham.blob.core.windows.net/test?restype=container&comp=list',
  apiPostSelectedOfferUrl: 'https://qaapi.fdcampaignstudio.com/dco/adapprovals',
  emailLinkUrl: 'https://qa.fdcampaignstudio.com/campaign_approval?randomcode=',
  offerApprovalApi: 'https://qaapi.fdcampaignstudio.com/dco/offerapprovals',
  offerApprovalEmailLink:
    'https://qa.fdcampaignstudio.com/offer-approval/dealer',
  offer_email_subject: 'Action Required: Please select offers',
  offer_email_body:
    'Hello <dealer-business-name>,  \n\nNew offers have just been announced on buyfordnow.com. Please click on the link to review and select the offers you would like to highlight this month. \n\n<link>\n\nThank you\n<userFirstName>',
  offer_email_from: 'admin@fdcampaignstudio.com',
  apigetAdgroup: 'http://devapi.fdcampaignstudio.com/google-ads/getAdGroups',
  apigetAccountNumber:
    'http://devapi.fdcampaignstudio.com/google-ads/getAccountName',
  submitToGoogleUrl:
    'http://devapi.fdcampaignstudio.com/google-ads/createSearchAd',
  apiCreateLabel: 'http://devapi.fdcampaignstudio.com/google-ads/createLabel',
  nodeUrl: 'http://127.0.0.1:3000',
  storageUri: 'https://creativesham.blob.core.windows.net/',
  storageContainer: 'test',
  udlApiStatusUrl: 'https://qaapi.fdcampaignstudio.com/udldelta/status/health',
  dcoApiStatusUrl: 'https://qaapi.fdcampaignstudio.com/dco/status/health',
  appVersion: '1.0-QA',

  apiUrlToSenEmail : 'https://qaapi.fdcampaignstudio.com/dco/dcousers/api/send-email',
  apiUrlToManageProject : 'https://qaapi.fdcampaignstudio.com/dco/dcousers/api/email-sms-backup',
  apiUrlEmailAnalytics : 'https://qaapi.fdcampaignstudio.com/dco/dcousers/api/email-analytics',
  apiUrlEmailAnalyticsLog : 'https://qaapi.fdcampaignstudio.com/dco/api/analytics',
  udldKeYread:"U2FsdGVkX1+WcBOboPpKFmr4Zbzh6UGwe7+uDIk5i++KbXp1F2sAS99lpzPnesE95mrnJu2Q25YIV03RItGvelW8QWStzxvDewbpzMU0tPWNSE0qip/gn9uXOJM785X64TWUuC00i/WQ6qyDZKv51YQhWSZgeluCIpKZsqBMkBOkREaUiFexW/XOzeleqTZeuoivGEVLTmmlM+WCdXmH04siw7tufcIe87PVVMBTHvyRezOsozVBPlnBMuPSIrYDfEAm3wGUOHyit6Rt0qeiayxSniLuufKIoD4dwbGcOz200x6H+yp2SpU1BQXrYA0QZLtr2bvd+fw/0ZP62/NUmOaYtNHOPU7sp/3Dv/fvYHAJr53waNunhNHUUMfPDa2UXPlL4bCjrSWB4H086na+9vgvWaOwJAHjYrWKu9+gfkJWtZ73eF6ZF/CSEfpDjYZ+Y0Du+jJlUTUIC/3Hz8TjNCjNbMfx3OoWW6jSfWXk2/wxU7X1qyrfZjpHZJGDtP2nDm2PUnw2mZuiQnWfu++ydNy8om6zW2F1Fmu8ir39BggKrEEL0hAmyAygrO8fqniWUADAc1NBBe1qTObL3q0iUa6+X5yt66xnir8Zj7rE8jjee/wB/t5BqMW21/Lf41eF"

};


